import { render, staticRenderFns } from "./Abuelapp.vue?vue&type=template&id=7b6c48a0&scoped=true"
import script from "./Abuelapp.vue?vue&type=script&lang=js"
export * from "./Abuelapp.vue?vue&type=script&lang=js"
import style0 from "./Abuelapp.vue?vue&type=style&index=0&id=7b6c48a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c48a0",
  null
  
)

export default component.exports